// TrailerBlocker.js
'use strict';
import { connect } from 'react-redux';

import TrailerBlocker from '../component/TrailerBlocker.jsx';

import { PREVIEW_PRESET, TRAILER_BLOCKER_URL } from '../RemoteConfigKeys.js';
import {
  CONFIG_PRIORITY_CONFIGURE,
  CONFIG_PRIORITY_PRESENCE_USER,
  CONFIG_PRIORITY_PRESENCE_CLIENT,
} from '../resource/configPriority.js';

import addModal from '../action/addModal.js';
import login from '../action/login.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';

const mapStateToProps = state => {
  const token = getMeData(state, 'token');
  const preset = getRemoteConfigData(state, PREVIEW_PRESET);
  return {
    isAuthed: !!getMeData(state, 'id'),
    shouldBlock: preset !== 'clear',
    blockerUrl: getRemoteConfigData(state, TRAILER_BLOCKER_URL),
    isRemoteConfigMerged: token
      ? getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_USER)
      : getIsRemoteConfigMerged(state, CONFIG_PRIORITY_PRESENCE_CLIENT) ||
        getIsRemoteConfigMerged(state, CONFIG_PRIORITY_CONFIGURE),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    openVerifyFreeUserModal: () =>
      dispatch(addModal({ id: 'VerifyFreeUserModal', isHigherThanAll: true })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrailerBlocker);
